export default __webpack_public_path__ + "static/media/donut-banner.6ad0a1f1.png";